import React, { Suspense, lazy, useEffect, useState } from 'react';
import { cachedCampaign, fetchCurrentCampaign } from '../../utils/campaigns';

// The band's code (layout, ornaments) is a chunk loaded only while a campaign
// is live; most of the year there is none and the home page skips it.
const CampaignBand = lazy(() => import('../CampaignBand'));

/** Home: the live seasonal campaign band (GET /campaigns/current), else
 *  nothing. The last answer (≤ 10 min) paints first; the fresh one replaces it. */
const HomeCampaign = () => {
  const [campaign, setCampaign] = useState(() => cachedCampaign() || null);

  useEffect(() => {
    let live = true;
    fetchCurrentCampaign().then((next) => { if (live) setCampaign(next); });
    return () => { live = false; };
  }, []);

  if (!campaign) return null;
  return (
    <Suspense fallback={null}>
      <CampaignBand campaign={campaign} />
    </Suspense>
  );
};

export default HomeCampaign;
